import raf from 'raf';
import debounce from 'lodash.debounce';
import Promise from 'promise-polyfill';
import helperUtilities from 'shared/mixins/helper-utilities';

const selector = '[data-js-timeline-advanced]';
const timelineAdvanced = function (el, app) {

	// const getCurrentMilestone = function () {
	// 	let $milestone = $milestonesWrapper.find('.Ge-Timeline-Advanced-Milestone--Current');
	// 	if ($milestone.length === 0) {
	// 		$milestone = $milestonesWrapper.find('.Ge-Timeline-Advanced-Milestone').last();
	// 	}
	// 	return $milestone;
	// };

	const $el = $(el);
	const $progressFuture = $el.find('.Ge-Timeline-Advanced-Progress-Bar-Future');
	const $progress = $el.find('.Ge-Timeline-Advanced-Progress-Bar-Base');
	const $progressCurrent = $el.find('.Ge-Timeline-Advanced-Progress-Bar-Latest');
	const $milestones = $el.find('.Ge-Timeline-Advanced-Milestone');
	// const $milestonesCurrent = getCurrentMilestone(); // $el.find('.Ge-Timeline-Advanced-Milestone--Current');
	const $milestonesWrapper = $el.find('.Ge-Timeline-Advanced-Progress-Milestones');

	let $milestonesCurrent = $milestones.filter('.Ge-Timeline-Advanced-Milestone--Current').eq(0);
	if( $milestonesCurrent.length === 0 ){
		$milestonesCurrent = $milestones.last();
	}

	const steps = $milestonesWrapper.data('steps');
	const stepWidth = 100 / steps;

	const init = function () {
		setProgress();
		setupEvents();
		setActiveMilestone();
		open($milestonesCurrent);
	};


	const setupEvents = function setupEvents() {
		$el.on('click touchstart', '.Ge-Timeline-Advanced-Milestone', event => {
			event.preventDefault();
			handleClick($(event.currentTarget));
		});
	};

	const handleClick = function handleClick($toggleClicked) {
		const hasCurrentClass = $toggleClicked.hasClass('Ge-Timeline-Advanced-Milestone--Current');
		open($toggleClicked);
	};

	const open = function open($toggleClicked = null, firstRun = false) {
		if (!$toggleClicked) {
			console.error("open called without a toggle item element");
			return;
		}

		const toggleClass = 'Ge-Timeline-Advanced-Milestone--toggled';

		if( $toggleClicked.hasClass(toggleClass)) {
			return;
		} else {
			$toggleClicked.addClass(toggleClass);
		}

		// 2. if we have a detail  to show, open tabs, close others
		const currentMilestoneId = $toggleClicked.data('timeline-detail-id');
		// if (!$currentMilestone) {
		// 	console.error("no acurrent miletone id present");
		// }

		if (currentMilestoneId) {

			// Just do this operation if we are on a second. user generated click or touch.
			closeOtherOpenTabs(currentMilestoneId);

			//const left = calculateArrowPos($toggleClicked)
			openTimelineTab(currentMilestoneId, $milestones.index( $toggleClicked ) * stepWidth + stepWidth/2 );
		}
	}

	function getUrlParameter(name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	};

/*	const initResizeWatch = function () {
		$(window).resize(function () {
			setProgress();
		});
	}
*/
	const closeOtherOpenTabs = function (exclude) {
		// we get a template passed by mustache, retrieve all templates, reset all but curretly clicked

		// Handle milestones graphocs internally to adv milestones
		let milestones = $('.Ge-Timeline-Advanced-Milestone').filter(`[data-timeline-detail-id!=${exclude}]`);

		milestones.removeClass('Ge-Timeline-Advanced-Milestone--toggled');

		const openStatusPages = $('[data-js-advanced-tab]');

		// Handle status pages
		openStatusPages.each((i, item) => {
			$(item).addClass('Ge-Hidden');
			$(item).removeClass('Ge-Timeline-Advanced-Section-Bottom-Tab--Staged');
		});

	}

	// Tab handling
	const openTimelineTab = function openTimelineTab(currentTabClicked, left = 0) {
		// here
		const $tab = $(`[data-js-advanced-tab-${currentTabClicked}]`);
		const $bottomSection = $('[data-advanced-milestones-bottom-section]');

		if (!$tab) {
			console.error("No current template found, advanced timeline");
			return;
		}
		if (!$bottomSection) {
			console.error("No current bottom section element found, advanced timeline");
			return;
		}

		// 1. Set up-arrow left prop to correct left before open.
		$tab
		 	.find('[data-js-advanced-tab-bottom-arrow]')
		 	.css('left', `${left}%`);

		// 2. put section on stage
		$bottomSection.removeClass( "Ge-Hidden"); //.show();

		// 3. Set the currently clicked tab to stage and animate
		const baseCss = 'Ge-Timeline-Advanced-Section-Bottom-Tab';
		$tab.toggleClass(`${baseCss}--Staged`);
		$tab.removeClass("Ge-Hidden");

		const message = `milestone-${currentTabClicked}`;
		// TODO: pass from mustache
		const template = ".Ge-Minasidor-Anslut-Status-Page";
		setTimeout(() => {
			app.trigger("milestoneActive", [message, template]);
		}, 200);
	}



	/*
	const watchProgress = function watchProgress() {
		observer = new MutationObserver(mutations => {
			setProgress();
		});

		observer.observe($progress.get(0), {
			attributes: true,
			attributeFilter: ['data-active-step']
		});
	};
*/
	const setProgress = function setProgress() {

		// get total nr of steps
		const activeStep = $milestonesWrapper.data('activeStep');

		//const activeStep = getUrlParameter( "Milestone");
		// Set gradient based on active step, so it gets proportional.
				
//		const measurements = translateStepsToPercentage(steps, activeStep);
		// const baseProgressWidth = measurements.pixels;   //Number(activeStep - 1) * stepWidth;
		// const currentProgressLeft = measurements.currentProgressStart;// + indicatorWidth;
		// const currentProgressWidth = measurements.currentProgressWidth;


		let progressStep = activeStep;
		//let nonFutureSteps = 0;
		const $milestone = $milestones.eq(activeStep);

		if( $milestone.hasClass( "Ge-Timeline-Advanced-Milestone--Future") || $milestone.hasClass( "Ge-Timeline-Advanced-Milestone--Cancelled") ){
			progressStep--;
			//nonFutureSteps = 1;
		}

		$progressFuture.css({
			width: (100-stepWidth /*-nonFutureSteps*stepWidth*/ ) +"%",
			marginLeft: (stepWidth/2) + "%"
		});

		if( progressStep < 0 ){
			return;
		}

		if( progressStep == 0 ){
			$progress.css({
				width: "0",
			});
			return;
		}
		
		if( progressStep == $milestones.length - 1 && $milestone.hasClass("Ge-Timeline-Advanced-Milestone--Past") ){
			$progress.css({
				width: (100-stepWidth) +"%",
				margin: "0 " + stepWidth/2 + "%"
			});
			return;
		}

		$progress.css({
			width: (progressStep * stepWidth) + "%",
			marginLeft: (stepWidth/2) + "%"
		});

		if( progressStep == activeStep ){
			$progressCurrent.css({
				width: (stepWidth*1) + "%",
				marginLeft: (activeStep * stepWidth - stepWidth/2) + "%"
			});
		}


	};

	const detectmob = () => {
		if (window.innerWidth <= 800 && window.innerHeight <= 600) {
			return true;
		} else {
			return false;
		}
	};


/*

	const translateStepsToPercentage = function (steps, activeStep) {
		// const percentageProgress = activeStep / (steps-1);

		let $last = $milestonesCurrent.length ? $milestonesCurrent : $milestones.last();
		
		// const activeIndicatorX = $($last).find('.Ge-Timeline-Advanced-Milestone--Current').offset().left;
		const activeIndicatorX = $last.offset().left;
		const milestoneWrapperX = $milestonesWrapper.offset().left;

		const pixelsProgress = activeIndicatorX - milestoneWrapperX;

		const milestoneWrapperXWidth = $milestonesWrapper.width();
		const currentProgressWidth = (milestoneWrapperXWidth-indicatorWidth) / (steps-1);

		let currentProgressStart = 0; //+ indicatorWidth;
		if (activeStep > 1) {
			currentProgressStart = currentProgressWidth * (activeStep - 2); //) + (indicatorWidth * (activeStep - 1));
		}

		currentProgressStart += indicatorWidth/2;

		let currentProgressEnd = pixelsProgress;
		if (detectmob()) {
			$progressCurrent.addClass('Ge-Timeline-Advanced-Progress-Bar-Latest--Mobile');
			currentProgressEnd = currentProgressEnd - $mobileMarginOffset;
			currentProgressStart = currentProgressStart - $mobileMarginOffset;
		}
		const x= {
			milestoneWrapperXWidth: milestoneWrapperXWidth,
			activeIndicatorX:activeIndicatorX,
			milestoneWrapperX:milestoneWrapperX,
			indicatorWidth:indicatorWidth,

			// percent: percentageProgress,
			pixels: pixelsProgress,
			currentProgressStart: currentProgressStart,
			currentProgressEnd: currentProgressEnd,
			currentProgressWidth: currentProgressWidth
		};

		console.dir( x);
		return x;
	}
*/
	const setClassGradient = function setClassGradient(steps) {
		let progressCssClass;
		let baseCss = 'Ge-Timeline-Advanced-Progress-Bar-Base';

/*		switch (steps) {
			case 1:
				progressCssClass = `${baseCss}-first`
				break;
			case 2:
				progressCssClass = `${baseCss}-second`
				break;
			case 3:
				progressCssClass = `${baseCss}-third`
				break;
			case 4:
				progressCssClass = `${baseCss}-fourth`
				break;
			case 5:
				progressCssClass = `${baseCss}-fifth`
				break;
			case 6:
				progressCssClass = `${baseCss}-sixth`
				break;
			case 7:
				progressCssClass = `${baseCss}-seventh`
				break;
			default:
				progressCssClass = `${baseCss}-first`
		}*/
		$progress.addClass(progressCssClass);
	}

	const setActiveMilestone = function() {

		// let currentActiveMilestoneId = $milestonesWrapper.data('active-milestone');
		// let $activeMilestoneId = $el.find(`[data-timeline-detail-id='${currentActiveMilestoneId}']`);

		// If we have a curret class, do cleanup
/*		if ($milestonesCurrent.length) {
			removeSpinner($milestonesCurrent);
			resetToDefault($milestonesCurrent);
		}*/
		// updateToCurrentMilestone($activeMilestoneId);
		app.trigger('milestoneActive');
	}

/*
	const removeSpinner = function cleanCurrentBox($milestonesCurrent) {
		$milestonesCurrent
			.find('Ge-Timeline-Advanced-Milestone-Indicator-Spinner-Box')
			.hide();
	}

	const resetToDefault = function updateMilstoneDefault($milestonesCurrent) {
		let $elem = $milestonesCurrent;
		$elem
			.find(".Ge-Timeline-Advanced-Milestone-Indicator")
			.addClass('Ge-Timeline-Advanced-Milestone-Indicator--Ansluta-Check');

		$elem
			.removeClass('Ge-Timeline-Advanced-Milestone--Current')
			.addClass('Ge-Timeline-Advanced-Milestone--Past');

	}
*/
/*
	const updateToCurrentMilestone = function updateMilestoneToCurrent($activeMilestoneId) {

		if( !$activeMilestoneId.hasClass( "'Ge-Timeline-Advanced-Milestone--Current") ){
			return;
		}

		// $activeMilestoneId
		// 	.find('.Ge-Timeline-Advanced-Milestone-Indicator')
		// 	.removeClass('Ge-Timeline-Advanced-Milestone-Indicator--Ansluta-Check');

		// $activeMilestoneId
		// 	.removeClass('Ge-Timeline-Advanced-Milestone--Past')
		// 	.addClass('Ge-Timeline-Advanced-Milestone--Current');

		// $activeMilestoneId
		// 	.find('.Ge-Timeline-Advanced-Milestone-Indicator-Spinner-Box')
		// 	.show();
	}
*/
/*
	// Utils
	const calculateArrowPos = function ($toggleClicked) {

		let currentLeftPX = 0;
		currentLeftPX = $($toggleClicked).offset().left;
		if ($toggleClicked.is('.Ge-Timeline-Advanced-Milestone--Current')) {
			currentLeftPX = currentLeftPX - 15;
		};

		const progressElemLeft = $('.Ge-Timeline-Advanced-Prograss-Inner').offset().left;
		const progressElemWidth = $('.Ge-Timeline-Advanced-Prograss-Inner').width();
		const progressYPos = (currentLeftPX - progressElemLeft) + 15;
		const progressYPercentage = (progressYPos / progressElemWidth) * 100;
		return progressYPercentage;
	}
	const setMobileIndicators = function ($mileStoneIndicator) {
		return;
		const $nextElem = $($mileStoneIndicator).next();
		const $prevElem = $($mileStoneIndicator).prev();
		if (!$nextElem || !$prevElem) {
			return;
		}
		if (typeof $mileStoneIndicator.next() === "undefined") {
			$prevElem.css("margin-left", "30px");
			return;
		}
		if (typeof $mileStoneIndicator.prev() === "undefined") {
			$nextElem.css("margin-left", "30px");
			return;
		}
		if ($nextElem) {
			$nextElem.css("margin-left", "30px");
		}
		if ($prevElem) {
			$prevElem.css("margin-right", "30px");
		}

	}
*/

	return {
		init: init()
	};
};

timelineAdvanced.selector = selector;

export default timelineAdvanced;
